/**
 * Smooth scrolling to (anchor links or element)
 *
 * @example
 * scrollToElement();
 *
 * @author Fedor Kudinov <brothersrabbits@mail.ru>
 *
 * @param {Object} [options={}] - Options
 *
 * @returns {void}
 */
const scrollToElement = (options = {}) => {
    const defaults = {
        duration: 600,
        element: document,
        header: '.js-header',
    };

    const settings = $.extend({}, defaults, options);

    const $element = $(settings.element);
    const $header = $(settings.header);

    let id, offset, headerHeight = 0;

    $element.on('click', 'a[href*="#"]:not([href="#"])', function (event) {

        id = $(this).attr('href');
        const $target = $(id);

        if ($header.length) {
            headerHeight = $header.outerHeight();
        }

        if (!$target.length) return;

        offset = $target.offset().top - headerHeight;

        $('html, body').animate({scrollTop: offset}, settings.duration);

        return false;

    });

};

export default scrollToElement;
